import { render, staticRenderFns } from "./ArtikelList.vue?vue&type=template&id=40c7a7c6"
import script from "./ArtikelList.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtikelList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports